import { ThemeEvents } from '@theme/events';

class ProductPatchInfo extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    section.addEventListener(
      ThemeEvents.variantUpdate,
      this.updatePatch
    );
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    section.removeEventListener(
      ThemeEvents.variantUpdate,
      this.updatePatch
    );
  }

  async updatePatch(event) {
    const variant = event.detail.resource;

    if (!variant) return;

    const container = document.querySelector('product-patch-info');

    if (!container) return;

    try {
      const response = await fetch(
        `${window.location.pathname}?variant=${variant.id}&section_id=${container.closest('.shopify-section').id.replace('shopify-section-', '')}`
      );

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newPatch = doc.querySelector(
        'product-patch-info [ref="patchInfo"]'
      );

      if (newPatch) {
        container.querySelector('[ref="patchInfo"]').replaceWith(newPatch);
      }

    } catch (e) {
      console.error(e);
    }
  }
}

if (!customElements.get('product-patch-info')) {
  customElements.define(
    'product-patch-info',
    ProductPatchInfo
  );
}